/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetNotificationSettingsResult } from '../../models/get-notification-settings-result';

export interface GetSettings$Params {}

export function getSettings(
  http: HttpClient,
  rootUrl: string,
  params?: GetSettings$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetNotificationSettingsResult>> {
  const rb = new RequestBuilder(rootUrl, getSettings.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetNotificationSettingsResult>;
    }),
  );
}

getSettings.PATH = '/Notifications/settings';
